/**
 * The organization scopes this console asks for. They must stay in step with the organization
 * template registered on Logto; the internal API authorizes against the same strings, and a scope
 * not requested here is simply absent from the token however the role reads in Logto.
 *
 * Asking for more than the signed-in account holds is harmless — Logto mints only what the
 * member's roles grant.
 */
export const STAFF_ORGANIZATION_SCOPES = [
  // The shared-key routes, which judge staff by these two when a route declares nothing.
  'admin:read',
  'admin:write',
  'admin:manage',
  'ax:read',
  'ax:write',
  'ax:manage',
  'category:read',
  'category:write',
  'category:manage',
  'developer:read',
  'developer:write',
  'developer:manage',
  'fulfillment:read',
  'fulfillment:write',
  'fulfillment:manage',
  'marketing:read',
  'marketing:write',
  'marketing:manage',
  'sourcing:read',
  'sourcing:write',
  'sourcing:manage',
  'company:read',
  // Teams added for MCP key access (SSD-6858): the Facade turns these into MCP groups, so they must be
  // requested here or they never reach the token.
  'cs:read',
  'cs:write',
  'cs:manage',
  'finance:read',
  'finance:write',
  'finance:manage',
  'bi:read',
  'bi:write',
  'bi:manage',
  'design:read',
  'design:write',
  'design:manage',
  'hr:read',
  'hr:write',
  'hr:manage',
  'partnership:read',
  'partnership:write',
  'partnership:manage',
] as const;

export type StaffOrganizationScope = (typeof STAFF_ORGANIZATION_SCOPES)[number];
